import { cn } from '../../lib/utils'

interface ScopeItemProps {
  name: string
  description: string
  isNew?: boolean
}

export function ScopeItem({ description, isNew = false }: ScopeItemProps) {
  return (
    <div
      className={cn(
        'flex items-start gap-3 rounded-lg p-3',
        isNew && 'bg-[var(--warning-muted)]/20'
      )}
    >
      <div className="mt-0.5 flex-shrink-0">
        <svg
          className="h-5 w-5 text-[var(--success)]"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm text-[var(--text-primary)]">
          {description}
        </p>
        {isNew && (
          <span className="mt-1 inline-block rounded bg-[var(--warning-muted)] px-1.5 py-0.5 text-xs font-medium text-[var(--warning)]">
            New
          </span>
        )}
      </div>
    </div>
  )
}
